export default {
  common: {
    welcome: 'Welcome',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    home: 'Home',
    about: 'About Us',
    contact: 'Contact Us',
    Jewelry: 'Jewelry Sales',
    jewelrySales: 'Welcome to use the Jewelry Sales System！',
    pleaseInput: 'Please input',
    pleaseSelect: 'Please select',
    hello: 'Hello!',
    modifyPassword: 'MUP',
    quit: 'Quit',
    Selection: 'Selection',
    Shape: 'Shape',
    Color: 'Color',
    Clarity: 'Cla',
    Cut: 'Cut',
    Polish: 'Polish',
    Sym: 'Sym',
    Flu: 'Flu',
    Weight: 'Weight',
    Ct: 'Ct',
    Details: 'Details',
    Remark: 'Remark',
    Cert: 'Cert',
    CertNo: 'CertNo',
    STOCKID: 'StockID',
    OrderNo: 'OrderNo',
    Place: 'Place',
    SaleStatus: 'SaleStatus',
    Price: 'Price/$',
    Discount: 'Discount',
    Rating: 'Rating',
    Year: 'Year',
    Size: 'Size',
    Table: 'Table',
    Depth: 'Depth',
    Ratio: 'Ratio',
    Status: 'Status',
    Action: 'Action',
    Operator: 'Operator',
    OrderDate: 'OrderDate',
    Round: 'Round',
    Princess: 'Princess',
    Radiant: 'Radiant',
    Asscher: 'Asscher',
    Marquise: 'Marquise',
    Oval: 'Oval',
    Emerald: 'Emerald',
    Pear: 'Pear',
    Heart: 'Heart',
    Cushion: 'Cushion',
    Triangle: 'Triangle',
    Others: 'Others',
    JewelryInformation: 'Jewelry Information',
    Selected: 'Selected',
    TotalW: 'Total Weight',
    TotalP: 'Total Price',
    Customer: 'Customer',
    Order: 'Order',
    Orders: 'Orders',
    Cart: 'Cart',
    Listings: 'Listings',
    Information: 'Information',
    welcome: 'Welcome to login!',
    RealName: 'Real Name',
    LoginTimes: 'Login Times',
    JoinTime: 'Join Time',
    LastLogin: 'Last Login',
    account: 'Account',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirm: 'Confirm',
    Tips: 'Tips',
    confirmLogout: 'Confirm Logout',
    diamondSelect: 'Diamond Search',
    colorDiamondSelect: 'Color Diamond Search',
    shoppingCart: 'Shopping Cart',
    orderCenter: 'Order Center',
    produceCenter: 'Produce Center',
    personalCenter: 'Personal Center',
    languageSwitch: 'Language Switch',
    Account: 'Account',
    Phone: 'Phone',
    Company: 'Company',
    Image: 'Image',
  },
  pagination: {
    total: 'Total {total} items',
    sizes: 'items/page',
    prev: 'Previous',
    next: 'Next',
    jumper: 'Go to',
    page: 'page'
  },
  // Framework Menu
  menu: [{
    menuId: 0,
    home: 'home',
    menuName: 'Data Center',
    region: 'Address Information Management',
    shipper: 'Owner Management',
    unit: 'Unit Management',
    unitMath: 'Material Unit Conversion Management',
    materialData: 'Material Data Management',
    materialGroup: 'Material Group Management',
    delivery: 'Ship-To Party Management',
    sold: 'Sold-To Party Management',
    business: 'Department Management',
    carriers: 'Shippers Management',
    driver: 'Driver Management',
    carManage: 'Vehicle Management',
    factoryDc: 'Factory Inventory',
    warehouse: 'Warehouse Management',
    shipperWarehouseStrategy: 'Points Warehouse Strategy',
    unloading: 'Unloading Point Management',
    material: 'Materials',
    orgStrategy: 'Org Strategy',
    orgRelationship: 'Org Relationship',
    nodeGroup: 'Node Group'
  }, {
    menuId: 1,
    menuName: 'System Management',
    user: 'User Management',
    role: 'Role Management',
    resource: 'Menu Management',
    appRight: 'Application Right Management',
    dataRight: 'Data Right Management',
    org: 'Org Management',
    log: 'Log Management',
    systemlog: 'System Log',
    portlog: 'Port Log'
  }, {
    menuId: 2,
    menuName: 'Orders Center',
    sourceOrder: 'Source Order Management',
    orderManage: 'Order Management',
    inStorage: 'Inventory Points Warehouse Management',
    outStorage: 'Outbound Points Warehouse Management',
    outStoragePlan: 'Outbound Plan Management',
    inStoragePlan: 'Inventory Plan Management',
    distribution: 'Distribution List Management',
    processOrder: 'Processing Order Management',
    storage: 'Inventory Management',
    warning: 'Early Warning Management',
    salesOrderList: 'Sales Order List',
    buyOrderList: 'Procurement Order List',
    moveOrderList: 'Move The Library Order List',
    inventoryInquireList: 'Inventory Inquire List',
    deliverList: 'Deliver List'
  }, {
    menuId: 3,
    menuName: 'Visual Center',
    processExecution: 'Doc View Process'
  }, {
    menuId: 4,
    menuName: 'Rule Configuration Center',
    orderBase: 'Orders Based Node Management',
    orderNodeClass: 'Order Node Classification Management',
    orderExtension: 'Order Node Extension Configuration',
    addressMap: 'Address Mapping Configuration',
    orgStrategy: 'Org Strategy',
    orgRelationship: 'Org Relationship',
    nodeGroup: 'Node Group'
  }],
  // Frame Top Right
  navTop: {
    search: 'Search',
    admin: 'Admin',
    exit: 'Exit',
    logo: {
      title: 'Wilmar',
      des: 'OMS Platform'
    }
  },
  // Common Buttons
  button: {
    add: 'Add',
    remove: 'Remove',
    update: 'Update',
    view: 'View',
    enable: 'Enable',
    disable: 'Disable',
    cancel: 'Cancel',
    confirm: 'Confirm',
    copy: 'Copy',
    logoutSuccess: 'Logout Success',
    tip: 'Tips',
    save: 'Save',
    close: 'Close',
    search: 'Search',
    reset: 'Reset',
    importExcel: 'Import',
    exportExcel: 'Export',
    upload: 'Upload',
    download: 'Download',
    resetPassword: 'Reset Password',
    login: 'Login',
    getCertNo: 'GetCertNo',
    export: 'Export Selected',
    exportAll: 'ExportAll',
    batchCancel: 'BatchCancel',
    batchOrder: 'BatchOrder',
    batchToCart: 'AddToCart',
    uploadRapnet: 'UploadRap',
  },
  // Operation Messages
  msg: {
    success: 'Success',
    error: 'Error',
    wechatDownloadTip: 'WeChat browser does not support file download. Please open in a browser（safari） to download.'
  }
} 


// WEBPACK FOOTER //
// ./src/i18n/en-US.js